import { Card, Tag, Button } from "antd";
import {
  MessageOutlined,
  PhoneOutlined,
} from "@ant-design/icons";
import { formatToCompanyTimezone } from "../../../../lib/functions";
import { resolveDialableNumber } from "../../../../lib/phone";

const LeadCard = ({
  lead,
  onCall,
  onClick,
  overdueCount,
  activeTaskCount,
  onViewActivity,
  isAdmin,
}) => {
  if (!lead) return null;

  const dialableNumber = lead.phone
    ? resolveDialableNumber(lead.phone, lead.country)
    : null;

  return (
    <Card
      className="lead-card"
      style={{
        borderRadius: 14,
        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
      }}
      onClick={() => onClick(lead)}
    >
      <div className="lead-row">
        <div style={{ flex: 1, minWidth: 0 }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              gap: 8,
            }}
          >
            <b style={{ flex: "1 1 auto", minWidth: 0, overflowWrap: "anywhere" }}>
              {lead.name}
            </b>

            <div
              style={{
                display: "flex",
                gap: 4,
                flexWrap: "wrap",
                flexShrink: 0,
                justifyContent: "flex-end",
              }}
            >
              {overdueCount > 0 && (
                <Tag color="red" style={{ margin: 0 }}>
                  {overdueCount} Overdue Task
                  {overdueCount > 1 ? "s" : ""}
                </Tag>
              )}

              {activeTaskCount > 0 && (
                <Tag color="blue" style={{ margin: 0 }}>
                  {activeTaskCount} Active Task
                  {activeTaskCount > 1 ? "s" : ""}
                </Tag>
              )}
            </div>
          </div>

          <div
            style={{
              fontSize: 12,
              color: "#888",
              marginTop: 2,
            }}
          >
            {dialableNumber || "-"}
          </div>

          <div
            style={{
              marginTop: 6,
              display: "flex",
              gap: 6,
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <Tag
              color={lead.status?.color || "default"}
              style={{
                maxWidth: "150px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {lead.status?.name || "-"}
            </Tag>

            <Tag
              style={{
                maxWidth: "150px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {lead.source || "-"}
            </Tag>
          </div>

          {isAdmin && (
            <div
              style={{
                fontSize: 12,
                marginTop: 6,
                color: "#666",
              }}
            >
              Agent: {lead.agent_name || "-"}
            </div>
          )}

          <div
            style={{
              fontSize: 12,
              marginTop: 4,
              color: "#666",
            }}
          >
            Updated:{" "}
            {lead.last_updated
              ? formatToCompanyTimezone(lead.last_updated)
              : "-"}
          </div>

          <div
            style={{
              fontSize: 12,
              color: "#666",
              marginTop: 4,
            }}
          >
            Created:{" "}
            {lead.date
              ? formatToCompanyTimezone(lead.date)
              : "-"}
          </div>
        </div>

        <div
          style={{
            display: "flex",
            gap: 8,
          }}
        >
          <Button
            shape="circle"
            icon={<PhoneOutlined />}
            onClick={(e) => {
              e.stopPropagation();
              onCall(lead.phone, lead.country);
            }}
          />

          <Button
            shape="circle"
            icon={<MessageOutlined />}
            onClick={(e) => {
              e.stopPropagation();
              onViewActivity?.(lead);
            }}
          />
        </div>
      </div>
    </Card>
  );
};

export default LeadCard;